define('collections/template/calendar/template-calendar-items',[
    'underscore', 'backbone', 'utils',
    // models
    'models/calendar/item/animated-session',
    // parent
    'collections/calendar/items'
], function(
    _, Backbone, U,
    // models
    MAnimatedSessionItem,
    // parent
    CCalendarItems
) {

    var CTemplateCalendarItems = CCalendarItems.extend({
        comparator: "_id",

        updateSession: function(session, template) {
            var templateSession = template.getSessions().get(session.id);

            if (templateSession) {
                var weekDiff = session.getWeekCount() - templateSession.getWeekCount();

                if (weekDiff) {
                    this.updateSessionItems(weekDiff, session);
                }

                this.each(function(model) {
                    if (model.get("session") === session.id) {
                        model.updateSession(session);
                    }
                });

                templateSession.reset(session.attributes);
            } else {
                template.getSessions().add(session);
                this.addSessionItems(session);
            }

            return this;
        },

        addSessionItems: function(session) {
            var itemsToAdd = session.getWeekCount(),
                sessionItemDayId = session.get('dayId');

            for (var i = 0; i < itemsToAdd; i++) {
                this.add(new MAnimatedSessionItem({
                    week: i,
                    dayId: sessionItemDayId + i * 7,
                    name: session.get('name'),
                    session: session.id
                }));
            }
        },

        updateSessionItems: function(weekDiff, session) {
            var sessionItems = this.where({ type: 'animated', session: session.id }),
                lastSessionItem;

            if (weekDiff > 0) {
                for (var i = 0; i < weekDiff; i++) {
                    lastSessionItem = _.last(this.where({ type: 'animated', session: session.id }));
                    this.add(new MAnimatedSessionItem({
                        session: session.id,
                        week: lastSessionItem.get('week') + 1,
                        dayId: lastSessionItem.get('dayId') + 7,
                    }));
                }
            } else {
                for (var j = 0; j > weekDiff; j--) {
                    var removed = sessionItems.pop();
                    this.remove(removed);
                }
            }
        },

        onNewModel: function(model) {
            if (!model.id) {
                model.setId(_.uniqueId('item'));
            }
        },
    });

    return CTemplateCalendarItems;
});

